import Vue from 'vue'
import Router from 'vue-router'
import Search from '@/components/Search'
import Data from '@/components/Data'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Search
    },
    {
      path: '/data',
      component: Data
    }
    // component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
  ]
})
